<template>
    <div class="ion-page">
        <ion-header class="rp-mobile">
            <ion-toolbar class="mobile-header-toolbar">
                <ion-buttons v-slot: start>
                    <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                    <ion-title>My E-Vehicles / {{vehicleId}}</ion-title>
                    <!-- <ion-buttons v-slot: end v-if="viewmode">
                    <ion-button @click="editVehicle" v-if="rightToUpdate"> -->
                        <!-- EDIT -->
                        <ion-icon v-slot: icon-only class="ios" :icon="create" @click="editVehicle" v-if="viewmode && rightToUpdate"></ion-icon>
                    <!-- </ion-button>
                    <ion-button @click="deleteVehicle" v-if="rightToDelete"> -->
                        <!-- DELETE -->
                        <ion-icon v-slot: icon-only class="ios" :icon="trash" @click="deleteVehicle" v-if="viewmode && rightToDelete"></ion-icon>
                    <!-- </ion-button> -->
                    <!-- <ion-button @click="homePage"> -->
                        <ion-icon :icon="homeSharp" v-if="!displayIosElement" @click="homePage"></ion-icon>
                        <ion-icon :icon="homeSharp" v-if="displayIosElement" class="edit-vehicle" @click="homePage"></ion-icon>
                        <!-- </ion-button> -->
                    <!-- </ion-buttons> -->
                </ion-buttons>
                <!-- <ion-buttons v-slot: end v-if="viewmode">
                    <ion-button @click="editVehicle" v-if="rightToUpdate"> -->
                        <!-- EDIT -->
                        <!-- <ion-icon v-slot: icon-only name="create"></ion-icon>
                    </ion-button>
                    <ion-button @click="deleteVehicle" v-if="rightToDelete"> -->
                        <!-- DELETE -->
                        <!-- <ion-icon v-slot: icon-only name="trash"></ion-icon>
                    </ion-button> -->
                <!-- </ion-buttons> -->
            </ion-toolbar>
        </ion-header>
        <ion-header class="rp-desktop">
            <ion-toolbar class="app-toolbar">
                <ion-buttons v-slot: start>
                    <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                    <ion-title>
                        My E-Vehicles /
                        <span class="ion-sub-title">{{vehicleId}}</span>
                    </ion-title>
                    <ion-buttons v-slot: end v-if="viewmode">
                        <ion-button class="ios-edit hdrBtn" @click="editVehicle" v-if="rightToUpdate">EDIT</ion-button>
                        <ion-button class="ios-edit hdrBtn" @click="deleteVehicle" v-if="rightToDelete">DELETE</ion-button>
                    </ion-buttons>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <EVehicleDetail v-if="!viewmode" />
            <EVehicleView v-if="viewmode" />
        </ion-content>
    </div>
</template>

<script>
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent, IonButton, alertController, IonIcon} from "@ionic/vue";
import { defineComponent } from "vue";
import { create, trash, homeSharp } from 'ionicons/icons';
import EVehicleDetail from "@/components/customer/MyEVehicleDetail.vue";
import EVehicleView from "@/components/customer/MyEVehicleView.vue";

import { VehicleService } from "../../service/vehicle/vehicle.service";
import { LocalStorage } from "../../data/localstorage";
import { Vehicle } from "../../entity/vehicle/vehicle";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { AppUtils } from "../../util/app-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

import { Capacitor } from "@capacitor/core";

export default defineComponent ({
    name: 'eVehicleDetail',
    components: {
        IonHeader, 
        IonToolbar, 
        IonButtons, 
        IonBackButton, 
        IonTitle, 
        IonContent, 
        IonButton,
        EVehicleDetail,
        EVehicleView,
        alertController,
        IonIcon
    },
    data() {
        return {
            homeSharp,
            create,
            trash,
            viewmode: false,
            rightToUpdate: false,
            rightToDelete: false,
            vehicleId: "New",
            displayIosElement: false
        }
    },
    async mounted() {
        const platform = Capacitor.getPlatform()
        if(platform == 'ios') {
            this.displayIosElement = true;
        }
        this.rightToUpdate = new AppUtils().getUserAccess("20|U");
        this.rightToDelete = new AppUtils().getUserAccess("20|D");
        if (this.$route.params.vehicleId && this.$route.params.vehicleId != 'R') {
            if (this.$route.query.mode) {
                this.viewmode = false;
                this.vehicleId = "Edit";
            } else {
                this.viewmode = true;
                this.vehicleId = "Detail"; // this.$route.params.vehicleId;
            }
        }
    },
    methods: {
        homePage() {
            let userRole = localStorage.getItem("user.roleId")
            if(userRole == 2) {
                this.$router.push("/customer/reservation")
            }
        },
        navigatePreviousPage() {
            this.$router.go(-1)
        },
        editVehicle() {
            this.viewmode = false;
            this.vehicleId = "Edit";
        },
        async deleteVehicle() {
            const alert = await alertController.create({
                header: "Confirm",
                message: "Are you sure want to delete?",
                buttons: [
                    {
                        text: "NO",
                        role: "cancel",
                        cssClass: "secondary",
                        handler: () => {
                            console.log('cancel')
                        }
                    },
                    {
                        text: "YES",
                        handler: () => {
                            this.deleteVehicleService();
                        }
                    }
                ]
            });

            await alert.present();

            // const alert = document.createElement("ion-alert");
            // alert.header = "Confirm";
            // alert.message = "Are you sure want to delete?";
            // alert.buttons = [
            //     {
            //     text: "NO",
            //     role: "cancel",
            //     cssClass: "secondary",
            //     handler: () => {
            //     }
            //     },
            //     {
            //     text: "YES",
            //     handler: () => {
            //         this.deleteVehicleService();
            //     }
            //     }
            // ];

            // document.body.appendChild(alert);
            // return alert.present();
        },
        async deleteVehicleService() {
            try {
                await new VehicleService().deleteVehicleForUser(
                new Vehicle(this.$route.params.vehicleId),
                new LocalStorage().user
                );
                new ToastUtils().presentToast("Vehicle deleted successfully");
                this.$router.back();
            } catch (error) {
                // let serviceError = tryParseServiceError(error);
                // new AlertUtils().presentAlert(serviceError ? serviceError : error);
                // new ToastUtils().presentToast(error.response.data.errors[0].detail);
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        }
    }
})
</script>


<style scoped>
.ios ion-icon {
  color: white;
  position: relative;
  left:50%;
  margin: 10px;
}

.ios .ios-edit{
  position: relative;
  left:240%;
  margin: 10px;
}

.edit-vehicle {
  color: white;
  position: relative;
  left:70%;
  margin: 10px;
    
}
ion-icon {
    color: white;
    margin: 10px;
}
@media (max-width: 768px) {
  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-button {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-back-button {
    color: #ffffff !important;
    margin-right: 13px;
  }
}
</style>